export { default } from './useGuestDataQueryByLocator';
export * from './useGuestDataQueryByLocator';
